import { Button, CircularProgress } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import ratePlanPagesRoleManagement from '../../staticRoleManagement/ratePlanRoleManagement'
import useStyles from './styles/RateplanFooter.styles'

interface RateplanFooterProps {
  isSubmitting: boolean
  loading: boolean
}

export const RateplanFooter: React.FC<RateplanFooterProps> = ({
  isSubmitting,
  loading
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm'))

  const hasAccessToEditRatePlanDetails = ratePlanPagesRoleManagement
    .find(
      (item) =>
        item.route ===
        '/accommodations/:accommodationID/:propertyCode/room-type/:roomTypeID/rate-plans/:id/providerCode/:providerCode/:page'
    )
    ?.tabs?.find((tabItem) => tabItem.params.page === 'details')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  return (
    <div className={classes.footer}>
      <Button
        disabled={isSubmitting || !hasAccessToEditRatePlanDetails || loading}
        variant="contained"
        color="primary"
        size="medium"
        type="submit"
        fullWidth={matches}>
        {getTranslate('Save Rate Plan')}
        {loading && (
          <CircularProgress className={classes.circularProgress} size={16} />
        )}
      </Button>
    </div>
  )
}
